"use client"

import React, { useEffect, useLayoutEffect } from "react"
import { useRouter, useSearchParams } from "next/navigation"
import { trackFactFinderProductClickByValuesAction } from "@/actions/factFinderTrackingActions"
import { useUbPDPState } from "@/store/ubPDPState"
import { useUbStorefrontState } from "@/store/ubStorefrontState"

import { generateProductLink } from "@/lib/link-utils/link-utils"
import { PdpContext } from "@/lib/storefront/product/pdp-service"
import { getFactFinderSessionQuery } from "@/lib/tracking/factfinder-session-attribution"
import { logTrackingFromServerResponse } from "@/lib/tracking/tracking-logger"
import { UseFilteredVariantsHook } from "@/components/product/pdp/UseFilteredVariantsHook"

export interface FilterNavigationProps {
  pdpContext: PdpContext
}

export function FilterNavigation(props: FilterNavigationProps) {
  const { filterClicked, setFilterClicked, setSelectedFilterOptions, setUseClientSelectedFilterOptions } =
    useUbPDPState()
  const { setIsLoading } = useUbStorefrontState()

  const masterProduct = props.pdpContext.productAndArticle.masterProduct
  const article = props.pdpContext.productAndArticle.article

  const filteredVariants = UseFilteredVariantsHook(masterProduct).filteredVariants

  const searchParams = useSearchParams()
  const searchParamsString = searchParams.toString()
  const router = useRouter()

  useLayoutEffect(() => {
    const selectedFilterOptions = { ...(props.pdpContext.selectedFilterOptions ?? {}) }
    const querySearchParams = new URLSearchParams(searchParamsString)
    const pdpsa = querySearchParams.get("pdpsa")?.trim()
    const pdpsv = querySearchParams.get("pdpsv")?.trim()

    if (pdpsa && pdpsv) {
      selectedFilterOptions[pdpsa] = pdpsv
    }

    setSelectedFilterOptions(selectedFilterOptions)
    setUseClientSelectedFilterOptions(true)
  }, [
    props.pdpContext.selectedFilterOptions,
    searchParamsString,
    setSelectedFilterOptions,
    setUseClientSelectedFilterOptions,
  ])

  useEffect(() => {
    if (filteredVariants.length === 1 /*&& props.pdpContext.pdpViewMode === "MASTER_PRODUCT"*/ && filterClicked) {
      const targetUrl = generateProductLink(
        filteredVariants[0].title,
        filteredVariants[0].sku,
        searchParams,
        props.pdpContext.sbLocale
      )

      //window.location.replace(targetUrl)
      //window.history.pushState(null, '', targetUrl)
      setFilterClicked(false)
      //console.log("load article")
      setIsLoading(true)
      const trackingQuery = getFactFinderSessionQuery("pdp_variant_selection", [
        props.pdpContext.productId,
        masterProduct?.id,
        article?.id,
      ])
      trackFactFinderProductClickByValuesAction(
        filteredVariants[0].sku,
        filteredVariants[0].title,
        masterProduct?.id,
        "pdp_variant_selection",
        1,
        trackingQuery
      ).then(logTrackingFromServerResponse, (error) =>
        console.error("Error calling trackFactFinderProductClickByValuesAction:", error)
      )
      router.push(targetUrl)
    } else {
      if (filteredVariants.length > 1 && props.pdpContext.pdpViewMode !== "MASTER_PRODUCT" && filterClicked) {
        /*        const targetUrl =
          generateProductLinkHelper(masterProduct?.title, masterProduct?.id) + `?${searchParams.toString()}`
        //window.location.replace(targetUrl)
        //window.history.pushState(null, '', targetUrl)
        setFilterClicked(false)
        console.log("load master")
        setIsLoading(true)
        router.push(targetUrl)*/
      }
    }
  }, [
    filterClicked,
    filteredVariants,
    masterProduct,
    article,
    props.pdpContext.pdpViewMode,
    props.pdpContext.productId,
    props.pdpContext.sbLocale,
    router,
    searchParams,
    setFilterClicked,
    setIsLoading,
  ])

  return <div className={"hidden"}></div>
}
